import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _bb668e3c = () => interopDefault(import('../../../pages/404-error/index.vue' /* webpackChunkName: "pages/404-error/index" */))
const _cced6960 = () => interopDefault(import('../../../pages/app/index.vue' /* webpackChunkName: "pages/app/index" */))
const _3cd23eac = () => interopDefault(import('../../../pages/buy-sell-your-home/index.vue' /* webpackChunkName: "pages/buy-sell-your-home/index" */))
const _4510b6a1 = () => interopDefault(import('../../../pages/buy-your-home/index.vue' /* webpackChunkName: "pages/buy-your-home/index" */))
const _0d338205 = () => interopDefault(import('../../../pages/calendar/index.vue' /* webpackChunkName: "pages/calendar/index" */))
const _5729b78e = () => interopDefault(import('../../../pages/commissions-calculator/index.vue' /* webpackChunkName: "pages/commissions-calculator/index" */))
const _be2c6bf0 = () => interopDefault(import('../../../pages/comparables/index.vue' /* webpackChunkName: "pages/comparables/index" */))
const _3325f88f = () => interopDefault(import('../../../pages/contact/index.vue' /* webpackChunkName: "pages/contact/index" */))
const _63946e05 = () => interopDefault(import('../../../pages/faq/index.vue' /* webpackChunkName: "pages/faq/index" */))
const _34f739b1 = () => interopDefault(import('../../../pages/favourites/index.vue' /* webpackChunkName: "pages/favourites/index" */))
const _2fc5e2c6 = () => interopDefault(import('../../../pages/list-home/index.vue' /* webpackChunkName: "pages/list-home/index" */))
const _08ccc51a = () => interopDefault(import('../../../pages/listing-management/index.vue' /* webpackChunkName: "pages/listing-management/index" */))
const _45174198 = () => interopDefault(import('../../../pages/login/index.vue' /* webpackChunkName: "pages/login/index" */))
const _33a7a16c = () => interopDefault(import('../../../pages/market-data/index.vue' /* webpackChunkName: "pages/market-data/index" */))
const _197bce93 = () => interopDefault(import('../../../pages/messages/index.vue' /* webpackChunkName: "pages/messages/index" */))
const _2ce53872 = () => interopDefault(import('../../../pages/my-abode-overview/index.vue' /* webpackChunkName: "pages/my-abode-overview/index" */))
const _4c0d5842 = () => interopDefault(import('../../../pages/my-listings/index.vue' /* webpackChunkName: "pages/my-listings/index" */))
const _34060dc1 = () => interopDefault(import('../../../pages/offer-management-buyer/index.vue' /* webpackChunkName: "pages/offer-management-buyer/index" */))
const _6b645cf2 = () => interopDefault(import('../../../pages/offer-management-seller/index.vue' /* webpackChunkName: "pages/offer-management-seller/index" */))
const _68ddb81e = () => interopDefault(import('../../../pages/offers/index.vue' /* webpackChunkName: "pages/offers/index" */))
const _49345412 = () => interopDefault(import('../../../pages/privacy/index.vue' /* webpackChunkName: "pages/privacy/index" */))
const _51b6de1e = () => interopDefault(import('../../../pages/pro-edit/index.vue' /* webpackChunkName: "pages/pro-edit/index" */))
const _75e6e1da = () => interopDefault(import('../../../pages/pro-marketplace/index.vue' /* webpackChunkName: "pages/pro-marketplace/index" */))
const _095e380f = () => interopDefault(import('../../../pages/pro-search/index.vue' /* webpackChunkName: "pages/pro-search/index" */))
const _172dd4a4 = () => interopDefault(import('../../../pages/request-sticker/index.vue' /* webpackChunkName: "pages/request-sticker/index" */))
const _6f5fcaef = () => interopDefault(import('../../../pages/search/index.vue' /* webpackChunkName: "pages/search/index" */))
const _4200e745 = () => interopDefault(import('../../../pages/sell-your-home/index.vue' /* webpackChunkName: "pages/sell-your-home/index" */))
const _ccd16b42 = () => interopDefault(import('../../../pages/signup/index.vue' /* webpackChunkName: "pages/signup/index" */))
const _251550b2 = () => interopDefault(import('../../../pages/sold-data/index.vue' /* webpackChunkName: "pages/sold-data/index" */))
const _050546cc = () => interopDefault(import('../../../pages/terms-of-service/index.vue' /* webpackChunkName: "pages/terms-of-service/index" */))
const _45f56577 = () => interopDefault(import('../../../pages/users/index.vue' /* webpackChunkName: "pages/users/index" */))
const _6b89e3e2 = () => interopDefault(import('../../../pages/whoweare/index.vue' /* webpackChunkName: "pages/whoweare/index" */))
const _cb4a160c = () => interopDefault(import('../../../pages/why-bode/index.vue' /* webpackChunkName: "pages/why-bode/index" */))
const _6fa6a0ca = () => interopDefault(import('../../../pages/admin/conversation/index.vue' /* webpackChunkName: "pages/admin/conversation/index" */))
const _ca9e6444 = () => interopDefault(import('../../../pages/admin/offers/index.vue' /* webpackChunkName: "pages/admin/offers/index" */))
const _355651d5 = () => interopDefault(import('../../../pages/admin/showings/index.vue' /* webpackChunkName: "pages/admin/showings/index" */))
const _7a31fde4 = () => interopDefault(import('../../../pages/listings/review.vue' /* webpackChunkName: "pages/listings/review" */))
const _1a2437be = () => interopDefault(import('../../../pages/login/idp/index.vue' /* webpackChunkName: "pages/login/idp/index" */))
const _b1311b50 = () => interopDefault(import('../../../pages/login/reset/index.vue' /* webpackChunkName: "pages/login/reset/index" */))
const _43d1151e = () => interopDefault(import('../../../pages/offers/constants/index.js' /* webpackChunkName: "pages/offers/constants/index" */))
const _f665c6e4 = () => interopDefault(import('../../../pages/offers/enums/index.js' /* webpackChunkName: "pages/offers/enums/index" */))
const _f7cbadea = () => interopDefault(import('../../../pages/pro-edit/profile/index.vue' /* webpackChunkName: "pages/pro-edit/profile/index" */))
const _3040f1d2 = () => interopDefault(import('../../../pages/pro-edit/service/index.vue' /* webpackChunkName: "pages/pro-edit/service/index" */))
const _1a9d51d7 = () => interopDefault(import('../../../pages/pro-marketplace/marketplace-for-pros/index.vue' /* webpackChunkName: "pages/pro-marketplace/marketplace-for-pros/index" */))
const _1def5394 = () => interopDefault(import('../../../pages/pro-marketplace/pro-login/index.vue' /* webpackChunkName: "pages/pro-marketplace/pro-login/index" */))
const _9f531392 = () => interopDefault(import('../../../pages/pro-marketplace/pro-portal/index.vue' /* webpackChunkName: "pages/pro-marketplace/pro-portal/index" */))
const _23183542 = () => interopDefault(import('../../../pages/pro-marketplace/service-request/index.vue' /* webpackChunkName: "pages/pro-marketplace/service-request/index" */))
const _4c1faa87 = () => interopDefault(import('../../../pages/pro-marketplace/service-requests/index.vue' /* webpackChunkName: "pages/pro-marketplace/service-requests/index" */))
const _e639a906 = () => interopDefault(import('../../../pages/search/saved-search-list/index.vue' /* webpackChunkName: "pages/search/saved-search-list/index" */))
const _2c82aee8 = () => interopDefault(import('../../../pages/signup/additional-information/index.vue' /* webpackChunkName: "pages/signup/additional-information/index" */))
const _c76c7e60 = () => interopDefault(import('../../../pages/signup/confirm/index.vue' /* webpackChunkName: "pages/signup/confirm/index" */))
const _45b42bb4 = () => interopDefault(import('../../../pages/admin/listings/import/index.vue' /* webpackChunkName: "pages/admin/listings/import/index" */))
const _caec5850 = () => interopDefault(import('../../../pages/admin/listings/update/index.vue' /* webpackChunkName: "pages/admin/listings/update/index" */))
const _f4f1b3ae = () => interopDefault(import('../../../pages/ds/callback/listing/index.vue' /* webpackChunkName: "pages/ds/callback/listing/index" */))
const _4f637281 = () => interopDefault(import('../../../pages/ds/callback/offer/index.vue' /* webpackChunkName: "pages/ds/callback/offer/index" */))
const _72d7325a = () => interopDefault(import('../../../pages/pro-marketplace/marketplace-for-pros/pro-sign-up/index.vue' /* webpackChunkName: "pages/pro-marketplace/marketplace-for-pros/pro-sign-up/index" */))
const _36f4f0ea = () => interopDefault(import('../../../pages/pro-marketplace/service-request/photography-measurements/index.vue' /* webpackChunkName: "pages/pro-marketplace/service-request/photography-measurements/index" */))
const _3531d231 = () => interopDefault(import('../../../pages/admin/listings/update/form/index.vue' /* webpackChunkName: "pages/admin/listings/update/form/index" */))
const _0e96bf52 = () => interopDefault(import('../../../pages/admin/listings/update/table/index.vue' /* webpackChunkName: "pages/admin/listings/update/table/index" */))
const _4a38a92c = () => interopDefault(import('../../../pages/pro-marketplace/marketplace-for-pros/pro-sign-up/successful/index.vue' /* webpackChunkName: "pages/pro-marketplace/marketplace-for-pros/pro-sign-up/successful/index" */))
const _473400be = () => interopDefault(import('../../../pages/admin/listings/update/form/constants/index.js' /* webpackChunkName: "pages/admin/listings/update/form/constants/index" */))
const _184c47e5 = () => interopDefault(import('../../../pages/admin/listings/update/form/controls/index.js' /* webpackChunkName: "pages/admin/listings/update/form/controls/index" */))
const _7c916c70 = () => interopDefault(import('../../../pages/admin/listings/update/form/listing-item/index.vue' /* webpackChunkName: "pages/admin/listings/update/form/listing-item/index" */))
const _41ba6d9b = () => interopDefault(import('../../../pages/admin/listings/update/services/AdminUpdateListingTableMapService.js' /* webpackChunkName: "pages/admin/listings/update/services/AdminUpdateListingTableMapService" */))
const _2e5eeeb1 = () => interopDefault(import('../../../pages/admin/listings/update/table/checkbox-cell.vue' /* webpackChunkName: "pages/admin/listings/update/table/checkbox-cell" */))
const _9c408550 = () => interopDefault(import('../../../pages/admin/listings/update/table/constants/index.js' /* webpackChunkName: "pages/admin/listings/update/table/constants/index" */))
const _9f692016 = () => interopDefault(import('../../../pages/admin/listings/update/table/enums/index.js' /* webpackChunkName: "pages/admin/listings/update/table/enums/index" */))
const _69d5c658 = () => interopDefault(import('../../../pages/admin/listings/update/table/header.vue' /* webpackChunkName: "pages/admin/listings/update/table/header" */))
const _ea1242de = () => interopDefault(import('../../../pages/admin/listings/update/table/mixins/AdminListingsUpdateTableRowsProps.js' /* webpackChunkName: "pages/admin/listings/update/table/mixins/AdminListingsUpdateTableRowsProps" */))
const _335d01df = () => interopDefault(import('../../../pages/pro-marketplace/profile/_id/index.vue' /* webpackChunkName: "pages/pro-marketplace/profile/_id/index" */))
const _195b263d = () => interopDefault(import('../../../pages/pro-marketplace/view-request/_id/index.vue' /* webpackChunkName: "pages/pro-marketplace/view-request/_id/index" */))
const _59a1595a = () => interopDefault(import('../../../pages/buyer-checklist/_page/index.vue' /* webpackChunkName: "pages/buyer-checklist/_page/index" */))
const _4a00f02f = () => interopDefault(import('../../../pages/how-it-works/_id/index.vue' /* webpackChunkName: "pages/how-it-works/_id/index" */))
const _303a8ce9 = () => interopDefault(import('../../../pages/listing-editing/_id/index.vue' /* webpackChunkName: "pages/listing-editing/_id/index" */))
const _4fb5c3e1 = () => interopDefault(import('../../../pages/listings/_id/index.vue' /* webpackChunkName: "pages/listings/_id/index" */))
const _6c6891c7 = () => interopDefault(import('../../../pages/pro/_id/index.vue' /* webpackChunkName: "pages/pro/_id/index" */))
const _3738a5fe = () => interopDefault(import('../../../pages/seller-checklist/_page/index.vue' /* webpackChunkName: "pages/seller-checklist/_page/index" */))
const _34feb701 = () => interopDefault(import('../../../pages/settings/_section/index.vue' /* webpackChunkName: "pages/settings/_section/index" */))
const _3dc44b08 = () => interopDefault(import('../../../pages/sold-property/_id/index.vue' /* webpackChunkName: "pages/sold-property/_id/index" */))
const _69140386 = () => interopDefault(import('../../../pages/user/_id/index.vue' /* webpackChunkName: "pages/user/_id/index" */))
const _0ea7196d = () => interopDefault(import('../../../pages/listings/_id/audit/index.vue' /* webpackChunkName: "pages/listings/_id/audit/index" */))
const _6e912166 = () => interopDefault(import('../../../pages/listings/_id/dashboard/index.vue' /* webpackChunkName: "pages/listings/_id/dashboard/index" */))
const _e9146adc = () => interopDefault(import('../../../pages/listings/_id/submit-success/index.vue' /* webpackChunkName: "pages/listings/_id/submit-success/index" */))
const _c36e28f8 = () => interopDefault(import('../../../pages/offers/_id/agreement/index.vue' /* webpackChunkName: "pages/offers/_id/agreement/index" */))
const _3ef6f38b = () => interopDefault(import('../../../pages/settings/_section/enums/index.js' /* webpackChunkName: "pages/settings/_section/enums/index" */))
const _16225ea9 = () => interopDefault(import('../../../pages/listings/_id/dashboard/enums.js' /* webpackChunkName: "pages/listings/_id/dashboard/enums" */))
const _1ed0da84 = () => interopDefault(import('../../../pages/listings/_id/viewings/_type/index.vue' /* webpackChunkName: "pages/listings/_id/viewings/_type/index" */))
const _95339c6e = () => interopDefault(import('../../../pages/users/_id/_section/index.vue' /* webpackChunkName: "pages/users/_id/_section/index" */))
const _78be4bbe = () => interopDefault(import('../../../pages/index.vue' /* webpackChunkName: "pages/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/404-error",
    component: _bb668e3c,
    name: "404-error"
  }, {
    path: "/app",
    component: _cced6960,
    name: "app"
  }, {
    path: "/buy-sell-your-home",
    component: _3cd23eac,
    name: "buy-sell-your-home"
  }, {
    path: "/buy-your-home",
    component: _4510b6a1,
    name: "buy-your-home"
  }, {
    path: "/calendar",
    component: _0d338205,
    name: "calendar"
  }, {
    path: "/commissions-calculator",
    component: _5729b78e,
    name: "commissions-calculator"
  }, {
    path: "/comparables",
    component: _be2c6bf0,
    name: "comparables"
  }, {
    path: "/contact",
    component: _3325f88f,
    name: "contact"
  }, {
    path: "/faq",
    component: _63946e05,
    name: "faq"
  }, {
    path: "/favourites",
    component: _34f739b1,
    name: "favourites"
  }, {
    path: "/list-home",
    component: _2fc5e2c6,
    name: "list-home"
  }, {
    path: "/listing-management",
    component: _08ccc51a,
    name: "listing-management"
  }, {
    path: "/login",
    component: _45174198,
    name: "login"
  }, {
    path: "/market-data",
    component: _33a7a16c,
    name: "market-data"
  }, {
    path: "/messages",
    component: _197bce93,
    name: "messages"
  }, {
    path: "/my-abode-overview",
    component: _2ce53872,
    name: "my-abode-overview"
  }, {
    path: "/my-listings",
    component: _4c0d5842,
    name: "my-listings"
  }, {
    path: "/offer-management-buyer",
    component: _34060dc1,
    name: "offer-management-buyer"
  }, {
    path: "/offer-management-seller",
    component: _6b645cf2,
    name: "offer-management-seller"
  }, {
    path: "/offers",
    component: _68ddb81e,
    name: "offers"
  }, {
    path: "/privacy",
    component: _49345412,
    name: "privacy"
  }, {
    path: "/pro-edit",
    component: _51b6de1e,
    name: "pro-edit"
  }, {
    path: "/pro-marketplace",
    component: _75e6e1da,
    name: "pro-marketplace"
  }, {
    path: "/pro-search",
    component: _095e380f,
    name: "pro-search"
  }, {
    path: "/request-sticker",
    component: _172dd4a4,
    name: "request-sticker"
  }, {
    path: "/search",
    component: _6f5fcaef,
    name: "search"
  }, {
    path: "/sell-your-home",
    component: _4200e745,
    name: "sell-your-home"
  }, {
    path: "/signup",
    component: _ccd16b42,
    name: "signup"
  }, {
    path: "/sold-data",
    component: _251550b2,
    name: "sold-data"
  }, {
    path: "/terms-of-service",
    component: _050546cc,
    name: "terms-of-service"
  }, {
    path: "/users",
    component: _45f56577,
    name: "users"
  }, {
    path: "/whoweare",
    component: _6b89e3e2,
    name: "whoweare"
  }, {
    path: "/why-bode",
    component: _cb4a160c,
    name: "why-bode"
  }, {
    path: "/admin/conversation",
    component: _6fa6a0ca,
    name: "admin-conversation"
  }, {
    path: "/admin/offers",
    component: _ca9e6444,
    name: "admin-offers"
  }, {
    path: "/admin/showings",
    component: _355651d5,
    name: "admin-showings"
  }, {
    path: "/listings/review",
    component: _7a31fde4,
    name: "listings-review"
  }, {
    path: "/login/idp",
    component: _1a2437be,
    name: "login-idp"
  }, {
    path: "/login/reset",
    component: _b1311b50,
    name: "login-reset"
  }, {
    path: "/offers/constants",
    component: _43d1151e,
    name: "offers-constants"
  }, {
    path: "/offers/enums",
    component: _f665c6e4,
    name: "offers-enums"
  }, {
    path: "/pro-edit/profile",
    component: _f7cbadea,
    name: "pro-edit-profile"
  }, {
    path: "/pro-edit/service",
    component: _3040f1d2,
    name: "pro-edit-service"
  }, {
    path: "/pro-marketplace/marketplace-for-pros",
    component: _1a9d51d7,
    name: "pro-marketplace-marketplace-for-pros"
  }, {
    path: "/pro-marketplace/pro-login",
    component: _1def5394,
    name: "pro-marketplace-pro-login"
  }, {
    path: "/pro-marketplace/pro-portal",
    component: _9f531392,
    name: "pro-marketplace-pro-portal"
  }, {
    path: "/pro-marketplace/service-request",
    component: _23183542,
    name: "pro-marketplace-service-request"
  }, {
    path: "/pro-marketplace/service-requests",
    component: _4c1faa87,
    name: "pro-marketplace-service-requests"
  }, {
    path: "/search/saved-search-list",
    component: _e639a906,
    name: "search-saved-search-list"
  }, {
    path: "/signup/additional-information",
    component: _2c82aee8,
    name: "signup-additional-information"
  }, {
    path: "/signup/confirm",
    component: _c76c7e60,
    name: "signup-confirm"
  }, {
    path: "/admin/listings/import",
    component: _45b42bb4,
    name: "admin-listings-import"
  }, {
    path: "/admin/listings/update",
    component: _caec5850,
    name: "admin-listings-update"
  }, {
    path: "/ds/callback/listing",
    component: _f4f1b3ae,
    name: "ds-callback-listing"
  }, {
    path: "/ds/callback/offer",
    component: _4f637281,
    name: "ds-callback-offer"
  }, {
    path: "/pro-marketplace/marketplace-for-pros/pro-sign-up",
    component: _72d7325a,
    name: "pro-marketplace-marketplace-for-pros-pro-sign-up"
  }, {
    path: "/pro-marketplace/service-request/photography-measurements",
    component: _36f4f0ea,
    name: "pro-marketplace-service-request-photography-measurements"
  }, {
    path: "/admin/listings/update/form",
    component: _3531d231,
    name: "admin-listings-update-form"
  }, {
    path: "/admin/listings/update/table",
    component: _0e96bf52,
    name: "admin-listings-update-table"
  }, {
    path: "/pro-marketplace/marketplace-for-pros/pro-sign-up/successful",
    component: _4a38a92c,
    name: "pro-marketplace-marketplace-for-pros-pro-sign-up-successful"
  }, {
    path: "/admin/listings/update/form/constants",
    component: _473400be,
    name: "admin-listings-update-form-constants"
  }, {
    path: "/admin/listings/update/form/controls",
    component: _184c47e5,
    name: "admin-listings-update-form-controls"
  }, {
    path: "/admin/listings/update/form/listing-item",
    component: _7c916c70,
    name: "admin-listings-update-form-listing-item"
  }, {
    path: "/admin/listings/update/services/AdminUpdateListingTableMapService",
    component: _41ba6d9b,
    name: "admin-listings-update-services-AdminUpdateListingTableMapService"
  }, {
    path: "/admin/listings/update/table/checkbox-cell",
    component: _2e5eeeb1,
    name: "admin-listings-update-table-checkbox-cell"
  }, {
    path: "/admin/listings/update/table/constants",
    component: _9c408550,
    name: "admin-listings-update-table-constants"
  }, {
    path: "/admin/listings/update/table/enums",
    component: _9f692016,
    name: "admin-listings-update-table-enums"
  }, {
    path: "/admin/listings/update/table/header",
    component: _69d5c658,
    name: "admin-listings-update-table-header"
  }, {
    path: "/admin/listings/update/table/mixins/AdminListingsUpdateTableRowsProps",
    component: _ea1242de,
    name: "admin-listings-update-table-mixins-AdminListingsUpdateTableRowsProps"
  }, {
    path: "/pro-marketplace/profile/:id",
    component: _335d01df,
    name: "pro-marketplace-profile-id"
  }, {
    path: "/pro-marketplace/view-request/:id",
    component: _195b263d,
    name: "pro-marketplace-view-request-id"
  }, {
    path: "/buyer-checklist/:page",
    component: _59a1595a,
    name: "buyer-checklist-page"
  }, {
    path: "/how-it-works/:id",
    component: _4a00f02f,
    name: "how-it-works-id"
  }, {
    path: "/listing-editing/:id",
    component: _303a8ce9,
    name: "listing-editing-id"
  }, {
    path: "/listings/:id",
    component: _4fb5c3e1,
    name: "listings-id"
  }, {
    path: "/pro/:id",
    component: _6c6891c7,
    name: "pro-id"
  }, {
    path: "/seller-checklist/:page",
    component: _3738a5fe,
    name: "seller-checklist-page"
  }, {
    path: "/settings/:section",
    component: _34feb701,
    name: "settings-section"
  }, {
    path: "/sold-property/:id",
    component: _3dc44b08,
    name: "sold-property-id"
  }, {
    path: "/user/:id",
    component: _69140386,
    name: "user-id"
  }, {
    path: "/listings/:id?/audit",
    component: _0ea7196d,
    name: "listings-id-audit"
  }, {
    path: "/listings/:id?/dashboard",
    component: _6e912166,
    name: "listings-id-dashboard"
  }, {
    path: "/listings/:id?/submit-success",
    component: _e9146adc,
    name: "listings-id-submit-success"
  }, {
    path: "/offers/:id/agreement",
    component: _c36e28f8,
    name: "offers-id-agreement"
  }, {
    path: "/settings/:section?/enums",
    component: _3ef6f38b,
    name: "settings-section-enums"
  }, {
    path: "/listings/:id?/dashboard/enums",
    component: _16225ea9,
    name: "listings-id-dashboard-enums"
  }, {
    path: "/listings/:id?/viewings/:type",
    component: _1ed0da84,
    name: "listings-id-viewings-type"
  }, {
    path: "/users/:id/:section",
    component: _95339c6e,
    name: "users-id-section"
  }, {
    path: "/",
    component: _78be4bbe,
    name: "index"
  }, {
    path: "/buyer-checklist",
    redirect: "/buyer-checklist/getting-ready",
    name: "/buyer-checklist"
  }, {
    path: "/how-it-works",
    redirect: "/how-it-works/seller",
    name: "/how-it-works"
  }, {
    path: "/howitworks",
    redirect: "/how-it-works/seller",
    name: "/howitworks"
  }, {
    path: "/listings",
    redirect: "/search",
    name: "/listings"
  }, {
    path: "/listings/:city/:community/:propertyType/:price/:id",
    redirect: "/listings/:id",
    name: "/listings/:city/:community/:propertyType/:price/:id"
  }, {
    path: "/logout",
    redirect: "/",
    name: "/logout"
  }, {
    path: "/error404",
    redirect: "/404-error",
    name: "/error404"
  }, {
    path: "/pro-:id-:companyname",
    redirect: "/pro/:id",
    name: "/pro-:id-:companyname"
  }, {
    path: "/profiles/:id",
    redirect: "/users/:id",
    name: "/profiles/:id"
  }, {
    path: "/seller-checklist",
    redirect: "/seller-checklist/getting-ready",
    name: "/seller-checklist"
  }, {
    path: "/start-listing",
    redirect: "/sell-your-home",
    name: "/start-listing"
  }, {
    path: "/terms",
    redirect: "/terms-of-service",
    name: "/terms"
  }, {
    path: "/whybode",
    redirect: "/why-bode",
    name: "/whybode"
  }, {
    path: "/who-we-are",
    redirect: "/whoweare",
    name: "/who-we-are"
  }, {
    path: "/offers/seller",
    redirect: "/offer-management-seller",
    name: "/offers/seller"
  }, {
    path: "/offers/buyer",
    redirect: "/offer-management-buyer",
    name: "/offers/buyer"
  }, {
    path: "/documents",
    redirect: "/offer-management-seller",
    name: "/documents"
  }, {
    path: "/list-your-home",
    redirect: "/list-home",
    name: "/list-your-home"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
